<template>
    <div class="tab-box">
        <ul class="tab-titles" :selectd-group=' titleGroup '>
            <li v-for=' (title, idx) in data.titles ' :key='idx'
                :class=' { "active" : idx==active } '
                @click=' setTab(idx, title.group) '
            >{{title.name}}</li>
        </ul>
        <div class="tab-body" v-for=' (compos, idx) in data.content ' :key='idx' v-show=' idx==active '>
            <div v-for=' (item, i) in compos ' :key='i' >
                <text-html v-if=' item.type==="text" ' :data='item' />
                <code-highlight v-else-if=' item.type==="code" ' :data='item' :isAdmin='isAdmin'/>
                <iv v-else-if=' item.type==="img" ' :data='item' />
                <h2 v-else-if=' item.type==="subtitle" ' v-html='item.content' />
                <youtube v-else-if=' item.type==="youtube" ' :data='item' />
                <exlink v-else-if=' item.type==="link" ' :data='item' />
                <collapse v-else-if=' item.type==="Collapse" ' :data='item' />
                <next v-else-if=' item.type==="next" ' :data='item' />
                <sb-oxq v-else-if=' item.type==="oxquiz" ' :data='item' />
                <sb-mcq v-else-if=' item.type==="quiz" ' :data='item' />
            </div>
        </div>
    </div>
</template>

<script>
import TextHtml from './TextHtml.vue';
import CodeHighlight from './CodeHighlight.vue';
import Image from './ImageLink.vue';
import Youtube from './Youtube.vue';
import ExternalLink from './ExternalLink.vue';
import Collapse from './Collapse.vue';
import NextButton from './NextButton.vue';
import OXQuiz from './OXQuiz.vue';
import MCQuiz from './MCQuiz.vue';

export default {
    name: 'tabs',
    components: {
        "text-html": TextHtml,
        "code-highlight": CodeHighlight,
        "iv": Image,
        "youtube": Youtube,
        "exlink": ExternalLink,
        "collapse": Collapse,
        "next": NextButton,
        "sb-oxq": OXQuiz,
        "sb-mcq": MCQuiz,
    },
    props: {
        isAdmin: { type: Boolean },
        data: { type: [Object, undefined] },
        titleGroup: { type: String }
    },
    data(){
        return {
            active: 0
        }
    },
    created(){
        this.isOpen = this.data.isOpen;
    },
    methods: {
        setTab(idx, group){
            this.active = idx;
            this.$emit('set-group', group);
        }
    },
    beforeUpdate(){ // console.log("beforeUpdate");
        for (let i = 0; i < this.data.titles.length; i++) {
            if ( this.titleGroup == this.data.titles[i].group ) {
                this.active = i;
                break;
            }
        }
    },

}
</script>

<style>
.tab-box .tab-titles {
    list-style: none;
    padding: 0; margin: 0;
}
.tab-box .tab-titles::after {
    clear: both;
    content: '';
    display: table;
}
.tab-box .tab-titles li {
    float: right;
    text-align: center;
    min-width: 20%;
    padding: 4px 16px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    cursor: pointer;
}
.tab-box .tab-titles li:first-child {
    border-right: 1px solid #ccc;
}
.tab-box .tab-titles .active {
    color: #008585;
    background: #efe;
}
.tab-box  .tab-body{
    border: 1px solid #ccc;
    padding: 10px;
}
</style>